
namespace RioERP.Reports {
    export class B2BColumns {
        static columnsKey = 'Reports.B2B';
    }
}